<template>
  <el-dialog
    v-if="showoff"
    :visible.sync="showoff"
    title="一键铺品"
    width="500px"
  >
    <div class="tip">添加为供应链商品，同时铺货到以下勾选铺货渠道</div>
    <el-checkbox-group v-model="typeVale">
      <el-col>
        <el-row style="padding: 6px 0">
          <el-checkbox :label="1" disabled>农博优选</el-checkbox>
          <div :aria-hidden="true">
            <el-radio-group v-model="isYXOnSale">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </div>
        </el-row>
        <el-row style="padding: 6px 0">
          <el-checkbox :label="2">渠道选品中心</el-checkbox>
        </el-row>
        <el-row style="padding: 6px 0">
          <el-checkbox :label="3">ERP</el-checkbox>
        </el-row>
        <el-row style="padding: 6px 0">
          <el-checkbox :label="4">中国土特产</el-checkbox>
          <div :aria-hidden="isTtcOnSaleDisabled ? 'true' : 'false'">
            <el-radio-group
              :disabled="isTtcOnSaleDisabled"
              v-model="isTtcOnSale"
            >
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </div>
        </el-row>
      </el-col>
    </el-checkbox-group>

    <div style="padding-top: 24px">
      <el-button type="primary" size="mini" @click="submitBtn">确定</el-button>
      <el-button size="mini" @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    return {
      showoff: false,
      typeVale: [1, 2, 3, 4],
      isYXOnSale: 1,
      isTtcOnSale: 1,
    };
  },
  computed: {
    isTtcOnSaleDisabled() {
      return !this.typeVale.includes(4);
    },
  },
  methods: {
    show(row) {
      this.row = row;
      this.showoff = true;
    },
    close() {
      this.showoff = false;
    },
    submitBtn() {
      const params = {
        type: "edit",
        goodsType: 1,
        backendCategoryId: this.row.backendCategoryId,
        goodsId: this.row.relationGoodsId,
        storeId: this.userInfo.defaultStoreId,
        suppliersId: this.userInfo.suppliersId,
        suppliedGoodsType: "add",
        suppliersName: this.row.relationSupplierName,
        goodsBuyType: this.row.goodsType,
        yxIsOnSale: this.isYXOnSale,
        scIsOnSale: this.typeVale.includes(2) ? 1 : 0,
        syncErp: this.typeVale.includes(3) ? 1 : 0,
        from: "yijianpupin",
      };
      this.typeVale.includes(4) && (params.ttcIsOnSale = this.isTtcOnSale);
      const route = this.$router.resolve({
        path: "/nb/goods/detail",
        query: params,
      });
      this.close();
      window.open(window.location.origin + route.href);
    },
  },
};
</script>

<style lang="scss" scoped>
.tip {
  margin-bottom: 20px;
}
.el-checkbox-group {
  margin-bottom: 50px;
}
</style>
